import { render, staticRenderFns } from "./ActionbarSave.vue?vue&type=template&id=0958dab2&"
import script from "./ActionbarSave.vue?vue&type=script&lang=ts&"
export * from "./ActionbarSave.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports